import { getKsdmConfig } from 'helpers/index';

/**
 * Phase 4a — `footer#ksdm-footer`, sizer variant
 * (`django/templates/common/sizerBase.html:20-34`).
 *
 * Unlike every other board this shell does NOT include `common/footer.html`:
 * it inlines its own two-column layout — copyright in a right-floated
 * `col-md-6` half and the version triple in a left-floated `col-md-6` half,
 * both inside a single `col-xs-12`. Prop-bending `PageFooter` cannot express
 * two sibling halves, so this is a local component (same call the reports and
 * AHU boards made — `ReportsBoardFooter` / `AhuBoardFooter`).
 *
 * ★ The version block is rendered UNCONDITIONALLY here — `sizerBase.html:26-30`
 * has no `{% if versions.software %}` guard, so the pipes show even with empty
 * versions. `versions.cms` is the composed `C.{Ymd}.{version}` token from
 * `react_views._cms_version`, which is what `sizerBase.html:29` builds inline.
 */
const SizerFooter = () => {
  const cfg = getKsdmConfig();
  const year = cfg?.year ?? new Date().getFullYear();
  const software = cfg?.versions?.software ?? '';
  const master = cfg?.versions?.master ?? '';
  const cmsVersion = cfg?.versions?.cms ?? '';

  return (
    <footer id="ksdm-footer">
      <div className="col-xs-12">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 right">
          <small id="ksdm-copyright" className="right">
            Powered by Kinetix Air | &#169; {year} Kinetix Software LLC | All Rights Reserved
          </small>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 left">
          <small id="ksdm-dbs-version" className="">
            <span className="ka-has-tooltip" tooltip="Software version">
              {software}
            </span>{' '}
            |{' '}
            <span className="ka-has-tooltip" tooltip="Master DB version">
              {master}
            </span>{' '}
            |{' '}
            <span className="ka-has-tooltip cms_version" tooltip="CMS DB version">
              {cmsVersion}
            </span>
          </small>
        </div>
      </div>
    </footer>
  );
};

export default SizerFooter;
